export const inaraDefaults = {
    appAutoUpdateEnabled: true,
    appAutoUpdateTime: '0:00',
    audioSourceView: 'control.audiosource',
    autoPushErrorLogs: true,
    calendarTimeBeforeDialAllowedMs: 5 * 60 * 1000,
    calendarView: 'control.calendar',
    cameraView: 'control.camera',
    channel: 'release',
    dialPadView: 'control.dialpad',
    directoryView: 'control.directory',
    displayView: 'control.display',
    displayViewNewLayout: true,
    idleEnabled: true,
    idleScreen: 'automatic',
    idleTimeout: 1,
    inCallView: 'control.calls',
    inkDuration: 300,
    kioskModeEnabled: true,
    language: 'en',
    lightingView: 'control.lighting',
    meetingCodeSendDelay: 5 * 1000,
    micsMuteBehaviorOnRoomPowerOff: 'unmute',
    modelNames: {
        'SM-T560NU': 'Mira Connect',
        'MCT-10HPQ': 'Mira Connect 10',
        'MCT-10HPQ-POE': 'Mira Connect 10',
    },
    name: 'Mira Connect',
    noView: 'control.noview',
    numRecentCalls: 20,
    o365CalendarEnabled: false,
    office365EventsQueryRangeMs: 15 * 24 * 60 * 60 * 1000,
    office365EventsRequeryRangeMs: 14 * 24 * 60 * 60 * 1000,
    office365EventsSubscriptionDurationMs: (4230 - 2) * 60 * 1000,
    otaUpgradeEnabled: false,
    platformWallpaper: 'www/img/aveo-logo.png',
    powerOffCancelTimeout: 60 * 1000,
    recentCallsEnabled: true,
    recentsView: 'control.recents',
    remoteControlEnabled: false,
    remoteControlName: 'Mira Connect Me',
    remoteControlSessionDurationMinutes: 60,
    remoteControlView: 'control.remote',
    roomPasswordView: 'roomPassword',
    roomPowerOffEnabled: false,
    screenCleaningTimeout: 20,
    setupFinishTimeout: 60 * 1000,
    setupIdleTimeout: 5,
    setupPageFlipDelay: 300,
    simulateEquipment: false,
    sleepEnabled: true,
    sleepTimeout: 10,
    telephonyDialingPrefixDelay: 0,
    timeFormat: 'h:mm A',
    timeZone: 'America/New_York',
    uiPreviewTimeoutMs: 30000,
    visualTheme: 'Blue Ridge',
};
export const inaraDefaults2 = Object.assign(Object.assign({}, inaraDefaults), { timeFormat: '12Hour' });
export const jayneDefaults = {
    smsNotificationTimestampFormat: 'MMM DD h:mm a z',
};
export const malDefaults = {
    name: 'Mira Portal',
    synergySkyApiDomain: 'api.use.joingw.com',
    synergySkyDomain: 'joingw.com',
    timestampFormat: 'h:mm a - D MMM YYYY',
    webAddress: 'https://mira.aveosystems.com',
};
export const roomControlServerDefaults = {
    apiTcpPort: 52838,
    name: 'Mira Connect Software',
};
export const defaults = {
    inara: inaraDefaults,
    jayne: jayneDefaults,
    mal: malDefaults,
    roomControlServer: roomControlServerDefaults,
    timestampFormat: 'YYYY MMM DD - h:mm a z',
};
export const defaults2 = Object.assign(Object.assign({}, defaults), { inara: inaraDefaults2 });
